export const MINIMUM_SCENE_TIME_DIFFERENCE = 3;
